import React from "react";
import { Skeleton, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import CustomCard from "../../CustomCard";
import CustomCircleButton from "../../CustomCircleButton";

const TopicLoadingCart = ({ type }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mt: "8px" }}>
      {Array(8)
        .fill("")
        .map((row, i) => {
          return (
            <Box key={i} sx={{ display: "flex" }}>
              {type === "discussion" && (
                <Box sx={{ ml: "2px", mr: "8px", mt: "auto", mb: "15px" }}>
                  <Skeleton
                    variant='circular'
                    width={48}
                    height={48}
                    sx={{
                      ml: "2px",
                    }}
                  />
                </Box>
              )}

              <CustomCard
                pSize={16}
                shadowSize={4}
                radius={16}
                maxHeight={type === "discussion" ? 166 : 146}
                mBottom={16}
              >
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {type === "discussion" && (
                    <Box sx={{ mb: "3px" }}>
                      <Skeleton
                        width={84}
                        height={18}
                        sx={{
                          pl: "2px",
                        }}
                      />
                    </Box>
                  )}

                  <Box
                    sx={{
                      display: "flex",
                      pb: "16px",
                      borderBottom: "2px solid",
                      borderColor: "black.main",
                      cursor: "pointer",
                    }}
                  >
                    <Skeleton
                      variant='rounded'
                      width={83}
                      height={64}
                      sx={{
                        borderRadius: "8px",
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        ml: "8px",
                        height: 64,
                        overflow: "hidden",
                        width: "100%",
                      }}
                    >
                      <Skeleton width={100} height={24} />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: "auto",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            maxWidth: "100px",
                          }}
                        >
                          <Skeleton width={100} height={10} />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            sx={{
                              fontSize: "10px",
                              lineHeight: "14px",
                              color: "mute.main",
                            }}
                          >
                            <Skeleton
                              width={type === "opinion" ? 70 : 45}
                              height={15}
                            />
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "secondary.main",
                        lineHeight: "16px",
                        cursor: "pointer",
                      }}
                    >
                      <Skeleton width={70} height={18} />
                    </Typography>
                    <Box sx={{ width: "24px", height: "24px" }}>
                      <CustomCircleButton
                        width='25px'
                        height='25px'
                        bgColor='white.main'
                        color='black.main'
                        bShadow='none'
                        hoverBgColor='white.main'
                        hoverColor='black.main'
                        hoverBorder={`1.5px solid ${theme.palette.black.main}`}
                        activeBgColor='black.main'
                        activeColor='white.main'
                      >
                        <ArrowForwardIosRoundedIcon
                          sx={{ fontSize: "14px", pl: "1.5px" }}
                        />
                      </CustomCircleButton>
                    </Box>
                  </Box>
                </Box>
              </CustomCard>
            </Box>
          );
        })}
    </Box>
  );
};

export default TopicLoadingCart;
